import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TourState = {
  openSidebar: boolean;
  liftSidebar: boolean;
  openWarningModal: boolean;
  windowSize: number;

  run: boolean;
  tour: string;
  activeStep: number;
  selectedRoute: string;
  routeToursCount: number;
};

const initialState: TourState = {
  openSidebar: false,
  liftSidebar: false,
  openWarningModal: false,
  windowSize: window.innerWidth,

  run: false,
  tour: '',
  activeStep: 0,
  selectedRoute: '',
  routeToursCount: 0,
};

const tourSlice = createSlice({
  name: 'tours',
  initialState,
  reducers: {
    setRun(state, action: PayloadAction<{ run: boolean; tour: string; open?: boolean }>) {
      state.tour = action.payload.tour;
      state.run = action.payload.run;
      state.openSidebar = action.payload.open ?? true;
      state.selectedRoute = location.pathname;
    },
    setRunTour(state, action: PayloadAction<boolean>) {
      state.run = action.payload;
    },
    setActiveStep(state, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    setOpenSidebar(state, action: PayloadAction<boolean>) {
      state.openSidebar = action.payload;
    },
    setLiftSidebar(state, action: PayloadAction<boolean>) {
      state.liftSidebar = action.payload;
    },
    setSelectedRoute(state, action: PayloadAction<string>) {
      state.selectedRoute = action.payload;
    },
    setRouteToursCount(state, action: PayloadAction<number>) {
      state.routeToursCount = action.payload;
    },
    setOpenWarningModal(state, action: PayloadAction<boolean>) {
      state.openWarningModal = action.payload;
    },
    setWindowSize(state, action: PayloadAction<number>) {
      state.windowSize = action.payload;
    },
  },
});

export const tourReducer = tourSlice.reducer;
export const tourActions = tourSlice.actions;
